import { Link } from "react-router-dom";

export default function WELPAR_2026() {
    return (
        <div className="mt-5 p-6 desktop:p-8 rounded-2xl border border-card-border bg-card-bg">
            <h3 className="text-xl font-bold mb-3 font-sans">Pendaftaran WELPAR 2026</h3>
            <p className="text-sm text-white/50 mb-5 font-sans leading-relaxed">
                Yuk, kenalan, seru-seruan, dan jadi bagian dari keluarga HIMSTAT lewat WELPAR × SIWU × HUT! 🎉
            </p>

            <Link
                to="/register-welpar"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-xl bg-white text-midnight text-sm font-bold font-sans no-underline hover-scale-btn hover-shadow-white"
            >
                Daftar WELPAR x SIWU
                <i className="fa-solid fa-arrow-right text-xs" />
            </Link>
        </div>
    );
}
